import DarkModeTwoToneIcon from "@mui/icons-material/DarkModeTwoTone";
import LightModeTwoToneIcon from "@mui/icons-material/LightModeTwoTone";
import { IconButton, Tooltip } from "@mui/material";
import { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { useVevyTheme } from "./ThemeProvider";

export default function ChangeThemeIcon() {
	const theme = useVevyTheme();
	const { t } = useTranslation();
	function changeMode(event: MouseEvent<HTMLElement>): void {
		theme.setDarkMode(!theme.isDark());
	}

	return (
		<Tooltip title={t("darklightmode")}>
			<IconButton
				size='large'
				aria-label='account of current user'
				aria-controls='menu-appbar'
				aria-haspopup='true'
				onClick={changeMode}
				color='inherit'
			>
				{theme.data.mode === "dark" ? (
					<LightModeTwoToneIcon />
				) : (
					<DarkModeTwoToneIcon />
				)}
			</IconButton>
		</Tooltip>
	);
}
